import firebase from 'firebase';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/functions';

const firebaseConfig = {
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_ID,
  apiKey: process.env.REACT_APP_FIREBASE_PUBLIC_API_KEY,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const app = firebase.initializeApp(firebaseConfig);
// const appCheck = firebase.appCheck();
// appCheck.activate(process.env.APPCHECK_RECAPTCHA_SECRET_KEY);

const storageBucketPath = `gs://${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_ID}`;

export const db = firebase.firestore(app);
export const auth = firebase.auth(app);
export const storage = app.storage(storageBucketPath);
export const functions = app.functions('australia-southeast1');

// functions.useEmulator('localhost', 5001);
// auth.useEmulator('http://localhost:9099');
// db.useEmulator('localhost', 8080);
// storage.useEmulator('localhost', 9199);

db.save = (collection, item) => {
  const timestamp = Math.floor(Date.now() / 1000);
  if (item.id) {
    const _item = { modifiedOn: timestamp, ...item };
    return db.collection(collection).doc(item.id).set(_item, { merge: true });
  }
  const _item = { modifiedOn: timestamp, isActive: true, createdOn: timestamp, ...item };
  return db
    .collection(collection)
    .add(_item)
    .then(docRef => docRef.set({ id: docRef.id }, { merge: true }));
};

db.list = collection => {
  return db
    .collection(collection)
    .where('isActive', '==', true)
    .orderBy('modifiedOn', 'asc')
    .get()
    .then(result => {
      return result.docs.map(doc => {
        return { ...doc.data(), id: doc.id };
      });
    });
};

db.updateQuizModifiedOn = () => {
  const timestamp = Math.floor(Date.now() / 1000);
  return db.collection('quizData').doc('modifiedOn').set({ modifiedOn: timestamp }, { merge: true });
};

db.saveQuizQuestion = (quizId, question) => {
  const timestamp = Math.floor(Date.now() / 1000);
  const ref = question.id
    ? db.collection('quizData').doc(quizId).collection('questions').doc(question.id)
    : db.collection('quizData').doc(quizId).collection('questions').doc();
  const data = question.id
    ? { modifiedOn: timestamp, ...question }
    : { createdOn: timestamp, modifiedOn: timestamp, ...question };
  return ref.set(data, { merge: true }).then(() => ({ id: ref.id }));
};

db.deleteQuizQuestion = (quizId, questionId) => {
  if (process.env.REACT_APP_ALLOW_DELETE !== 'true') return Promise.resolve();
  return db.collection('quizData').doc(quizId).collection('questions').doc(questionId).delete();
};

db.updateQuestionCount = quizId => {
  const timestamp = Math.floor(Date.now() / 1000);
  return db
    .collection('quizData')
    .doc(quizId)
    .collection('questions')
    .get()
    .then(snapshot =>
      db
        .collection('quizData')
        .doc(quizId)
        .set({ questionCount: snapshot.size, modifiedOn: timestamp }, { merge: true })
    );
};
